/**
 * OrivonAI Page Header System
 *
 * ALWAYS use <PageHeader> for every new page header.
 * NEVER use inline styles for H1 or H2 headers.
 * Level 1 page title: 22px Playfair inside .page-title-card (never above 22px for H1).
 * NEVER use font-size above 16px for section headers.
 *
 * Page title:    22px Playfair Display — .page-title inside .page-title-card
 * Section title: 16px Playfair Display — .section-title
 * Eyebrow:       10px Plus Jakarta Sans uppercase — .page-eyebrow (inside .page-title-card, above H1)
 * Descriptor:    12px Plus Jakarta Sans muted — .page-descriptor
 *
 * Chapter colors are set automatically via the chapter prop.
 * chapter="fertility" → pink palette (#D4537E)
 * chapter="ttc"       → purple palette (#7F77DD)
 *
 * Example usage:
 * <PageHeader
 *   chapter="fertility"
 *   eyebrow="Fertility · Health Record"
 *   title="Your health at a glance"
 *   descriptor="Labs, clinic notes, and cycle history."
 * />
 */
import React from 'react';
import '../styles/pageHeaders.css';

export default function PageHeader({ chapter, eyebrow, title, descriptor, trailing, className }) {
  const emoji = chapter === 'ttc' ? '🤍' : '🌸';
  const chapterClass = chapter === 'ttc' ? 'chapter-ttc' : 'chapter-fertility';
  const showEyebrow = eyebrow != null && String(eyebrow).trim() !== '';
  const extra = className ? ` ${className}` : '';
  return (
    <div className={`page-header-block ${chapterClass}${extra}`}>
      <div className="page-title-card">
        <div className="page-title-card__main">
          {showEyebrow ? (
            <div className="page-eyebrow">
              <span aria-hidden>{emoji}</span>
              <span>{eyebrow}</span>
            </div>
          ) : null}
          <h1 className="page-title">{title}</h1>
          {descriptor ? <p className="page-descriptor">{descriptor}</p> : null}
        </div>
        {trailing ? <div className="page-title-card__actions">{trailing}</div> : null}
      </div>
    </div>
  );
}
